export default __webpack_public_path__ + "static/media/logger.f80d196c.mp4";